<template>

<div class="navbar">
  <div class="inner">
    <NavbarBurger v-on:click="toggleSidebar"/>
    <router-link class="logo" :to="{name: 'Home'}">
      OGQ GYN <strong>DEEP MANAGER</strong>
    </router-link>
  </div>
</div>

</template>
<script>
import NavbarBurger from './NavbarBurger'
export default {
  setup() {

  },
  methods: {
    toggleSidebar() {
      this.$store.commit('toggleSidebar')
    }
  },
  components: {
    NavbarBurger
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--navbar-height);
  background: white;
  border-bottom: 1px solid var(--border-gray-900);
  z-index: 90;
}

.navbar > .inner {
  height: inherit;
  display: flex;
  align-items: center;
  margin: 0 40px;
  @media screen and (max-width: 1104px) {
    flex-direction: row-reverse;
    justify-content: space-between;
    margin: 0 0 0 20px;
  }
}

a.logo {
  display: block;
  color: var(--gray-900);
  text-decoration: none;
  height: var(--navbar-logo-height);
  margin-left: 18px;
  padding: 0 14px;
  font-size: 28px;
  line-height: var(--navbar-logo-height);
  border-radius: 8px;
  @media screen and (max-width: 1104px) {
    font-size: 17px;
    margin: 0 0 0 -14px;
  }
  &:hover {
    background-color: var(--gray-200)
  }
  &:active {
    background-color: var(--gray-300)

  }
}
</style>